export const apiUrls = {
    getAllRolesUrl: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/roles/getAllRoles`,
        method: "GET"
    },
    getAllDeptUrl: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/department/getAllDepartment`,
        method: "GET"
    },
    getAllAssignedUserUrl: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/userRoleDepartment/getAllUserRoleDept`,
        method: "GET"
    },
    getUserDetailsByUserId: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/userRoleDepartment/getUserRoleDeptInfo/{userId}`,
        method: "GET"
    },
    createDepartmentUrl: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/department/createDepartment`,
        method: "POST"
    },
    updateDepartmentUrl: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/department/updateDepartmentById/{deptId}`,
        method: "PUT"
    },
    createRolesUrl: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/roles/createRoles`,
        method: "POST"
    },
    updateRolesUrl: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/roles/updateRoles/{roleId}`,
        method: "PUT"
    },
    saveAssignedRolesUrl: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/roles/saveAssignedRoles`,
        method: "POST"
    },
    updateAssignedRolesUrl: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/roles/updateAssignedRoles`,
        method: "PUT"
    },
    deleteRolesById: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/roles/deleteRoles/{id}`,
        method: "DELETE"
    },
    deleteDepartmentById: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/roles/deleteDepartment/{id}`,
        method: "DELETE"
    },
    deleteAssignedRolesUrl: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/userRoleDepartment/deleteAssignedRolesDept/{userId}`,
        method: "DELETE"
    },



    /* Survey related URLs */
    getAllSurveyUrl: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/survey/getAllSurvey`,
        method: "GET"
    },
    getCountOfSurveyUrl: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/survey/getCountOfSurvey`,
        method: "GET"
    },
    getAllDraftSurveyUrl: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/survey/getAllDraftSurvey`,
        method: "GET"
    },
    getAllActiveSurveyUrl: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/survey/getAllPublishedSurvey`,
        method: "GET"
    },
    getAllActiveSurveyUrlNew: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/survey/getAllPublishedSurvey`,
        method: "GET"
    },
    getAllInactiveSurveyUrl: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/survey/getAllClosedSurvey`,
        method: "GET"
    },
    getSurveyByIdUrl: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/survey/getSurveyById/{id}`,
        method: "GET"
    },
    createSurveyUrl: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/survey/createSurvey`,
        method: "POST"
    },
    updateSurveyUrl: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/survey/updateSurvey/{id}`,
        method: "PUT"
    },

    createQuestionUrl: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/question/createQuestion`,
        method: "POST"
    },

    getQuestionTypes: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/optionType/getAllOptionType`,
        method: 'GET'
    },

    deleteSurvey:{
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/survey/deleteSurvey/{surveyId}`,
        method: "DELETE"
    },

    extendSurvey:{
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/survey/extendSurvey/`,
        method: "put"
    },
    //Publish survey

    publishSurvey: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/survey/publishSurvey`,
        method: 'POST'
    },
    publishSurveyWithQuestionOrder: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/survey/publishSurveyOrdFinal/{surveyId}`,
        method: 'POST'
    },

    getQuestionOptionGroups: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/optiongroup/getAllOptionGroup`,
        method: 'GET'

    },

    //get survey questions
    getSurveyQuestions: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/question/getSurveyQuestionBySurvId`,
        method: 'GET'

    },

    deleteQuestion: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/question/delete/`,
        method: 'GET'

    },

    deleteChildQuestion: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/question/deleteChildQues/`,
        method: 'GET'

    },

    updateQuestion: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/question/updateQuestionnaire/`,
        method: 'POST'
    },

    getSurveyResults: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/surveyresults/surveyResults`,
        method: 'GET'
    },

    getAllAnswersByQuestionId: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/surveyresults/useranswers/`,
        method: 'GET'
    },

    getAllRespondents: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/surveyresults/users/`,
        method: 'GET'
    },
    getExcelData: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/surveyresults/users/questionAnswers/{surveyId}`,
        method: 'GET'
    },

    getSurveyAnswersByusers: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/surveyresults/questionAnswers/`,
        method: 'GET'
    },

    // Emergency notification 

    // getAllUserGroups: {
    //     URL: `${process.env.REACT_APP_API_URL}/surveyapp/notification/userGroups`,
    //     method: 'GET'
    // },
    // getAllUserGroupsBySearch: {
    //     URL: `${process.env.REACT_APP_API_URL}/surveyapp/notification/userGroupsBySearch/{searchName}`,
    //     method: 'GET'
    // },
    // getAllPriority: {
    //     URL: `${process.env.REACT_APP_API_URL}/surveyapp/notification/priority`,
    //     method: 'GET'
    // },
    updateNotification: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_NOTIFICATION}/emergency-notifications`,
        // URL: `http://localhost:8091/emergency-notifications`,
        method: 'PUT'
    },
    createNotification: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_NOTIFICATION}/emergency-notifications`,
        // URL: `http://localhost:8091/emergency-notifications`,
        method: 'POST'
    },
    getAllDraftNotification: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_NOTIFICATION}/draft/emergency-notifications`,
        // URL: `http://localhost:8091/draft/emergency-notifications`,
        method: 'GET'
    },
    getAllSentNotification: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_NOTIFICATION}/emergency-notifications/sent`,
        // URL: `http://localhost:8091/sent/emergency-notifications`,
        method: 'GET'
    },
    getCountOfNotification: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_NOTIFICATION}/emergency-notifications/count`,
        // URL: `http://localhost:8091/emergency-notifications/count`,        
        method: 'GET'
    },
    deleteNotificationById: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_NOTIFICATION}/emergency-notifications/{notificationId}`,
        // URL: `http://localhost:8091/emergency-notifications/{notificationId}`,  
        method: 'DELETE'
    },
    getNotificationByStatus: {
        URL : `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_NOTIFICATION}/emergency-notifications/`,
        // URL: `http://localhost:8091/draft/emergency-notifications`,
        method: 'GET'
    },
   
    sendNotification: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_NOTIFICATION}/emergencyNotification/{notificationId}`,
        // URL: `http://localhost:8091/emergencyNotification/{notificationId}`,  
        method: 'POST'
    },
    sendNotificationLater: {
        URL: `http://localhost:8091/surveyapp/notification/sendNotificationLater/{notificationId}`,
        method: 'POST'
    },

    // news Apis


    createNewsUrl: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/news/mbrdi-news`,
        method: "POST"
    },

    getNewsCategoryList: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/news/getNewsCategoryList`,
        method: "GET"
    },

    getNewsTypeList: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/mbrdinews/get-news-types`,
        method: "GET"
    },

    updateNewsUrl:{
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/news/mbrdi-news`,
        method: "PUT"
        
    },

    getNewsByIdUrl: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/news/getAllMbrdiNewsById/{id}`,
        method: "GET"
    },

    getAllDraftNews:{
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/news/draft/mbrdi-news`,
        method: "GET"
    },

    getAllPublishedNews:{
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/news/published/mbrdi-news`,
        method: "GET"
    },

    getCountOfNews:{
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/news/mbrdi-news/count`,
        method: "GET"
    },
    
    getNewsDetailsById: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/news/getAllMbrdiNewsById/{newsId}`,
        method: "GET"
    },

    publishNews: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/news/publishMbrdiNews`,
        method: "POST"
    },
    
    deleteNews:{
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/news/mbrdi-news/{newsId}`,
        method: "DELETE"
    },
    uploadNewsImage:{
        URL:   `${process.env.REACT_APP_API_URL}/file-service/uploadImage/`,
        
        method: "POST"
    },
    deleteNewsImage:{
        URL:   `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/news/newsImage/`,
        method: "DELETE"
    },
    
    //video 
    createVideoUrl: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/video/mbrdi-video`,
        method: "POST"
    },

  

    updateVideoUrl:{
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/video/mbrdi-video`,
        method: "PUT"
        
    },

    getVideoByIdUrl: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/news/getAllMbrdiNewsById/{id}`,
        method: "GET"
    },

    getAllDraftVideos:{
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/video/draft/mbrdi-video`,
        method: "GET"
    },

    getAllPublishedVideos:{
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/video/published/mbrdi-video`,
        method: "GET"
    },

    getCountOfVideos:{
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/video/mbrdi-video/count`,
        method: "GET"
    },
    disableVideo:{
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/video/disableVideo`,
        method: "DELETE"
    },
    getVideoDetailsById: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/video/getAllVideosById/{newsId}`,
        method: "GET"
    },

    publishVideo: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/video/publishVideo/`,
        method: "POST"
    },
    
    deleteImage:{
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/video/deleteImage`,
        method: "DELETE"
    },

    uploadImage:{
        URL:   `${process.env.REACT_APP_API_URL}/file-service/uploadImage`,
        
        method: "POST"
    },
    uploadVideoFile:{
        URL:   `${process.env.REACT_APP_API_URL}/file-service/uploadVideo/`,
        
        method: "POST"
    },



    uploadCafeMenuData: {
      URL: `${process.env.REACT_APP_API_URL}/file-service/uploadCafeMenuData/`,
  
      method: 'POST',
    },
    deleteVideoFile:{
        URL:   `${process.env.REACT_APP_API_URL}/file-service/deleteVideo`,
        
        method: "DELETE"
    },
    //Temporary login & token URL

    loginUrl: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_USER}/no-auth/login`,
        method: "POST"
    },

    tokenUrl: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_USER}/fetchTokenForWeb`,
        method: "GET"
    },
    refreshTokenUrl: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_USER}/refreshToken`,
        method: "GET"
    },

    //Cafe menu table
  getCafeMenuTypes: {
    URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_USER}/cafe-menu/types`,
    method: 'GET',
  },
    getCafeMenuList: {
    URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_USER}/cafe-menu`,
    method: 'GET',
  },
  addCafeMenuList: {
    URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_USER}/cafe-menu`,
    method: 'POST',
  },
  editCafeMenuList: {
    URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_USER}/cafe-menu`,
    method: 'PUT',
  },
  deleteCafeMenuList: {
    URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_USER}/cafe-menu/{id}`,
    method: 'DELETE',
  },

  getCafeFeedbackList: {
    URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_USER}/cafeFeedBacks`,
    method: 'GET',
  },
  getCafeFeedbackListByDate: {
    URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_USER}/cafeFeedBackBetweenDate`,
    method: 'GET',
  },
  getCafeMenuTimings:{
    URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_USER}/cafe-menu/timings`,
    method:'GET',
  },
  getCafeMenuTimingsTypes:{
    URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_USER}/cafe-menu/timings/dropdown/types`,
    method:'GET',
  },
  postCafeMenuTimings:{
    URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_USER}/cafe-menu/timings`,
    method:'POST',
  },
  updateCafeMenuTimings:{
    URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_USER}/cafe-menu/timings`,
    method:'PUT',
  },
  deleteCafeMenuTimings:{
    URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_USER}/cafe-menu/timings/{id}`,
    method:'DELETE',
  },
  
  //Policy Docs Api
  getPolicyDocs: {
    URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_FILE}/policy/getPolicyDocs`,
    method: 'GET',
  },
  addPolicyDocs: {
    URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_FILE}/policy/policy-docs`,
    method: 'POST',
  },
  editPolicyDocs: {
    URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_FILE}/policy/policy-docs`,
    method: 'PUT',
  },
  deletePolicyDocs: {
    URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_FILE}/policy/policy-docs/{id}`,
    method: 'DELETE',
  },

  //App menu table
  getAppsList: {
    URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_USER}/getDeepLinkDetails`,
    method: 'GET',
  },
  addAppsList: {
    URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_USER}/deep-link`,
    method: 'POST',
  },
  editAppsList: {
    URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_USER}/deep-link/appStatus`,
    method: 'PUT',
  },
  deleteDeepLink: {
    URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_USER}/deep-link/`,
    method: 'DELETE',
  },
    // Analytics Dashboard

    getAllAnalyticsCount: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_ANALYTICAL}/analyticsCount`,
        method: "GET"
    },

    getUserTypeAnalyticsCount: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_ANALYTICAL}/user-type-count`,
        method: "GET"
    },
    getSurveyCountByMonth: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_ANALYTICAL}/getActiveSurveysByMonth/`,
        method: "GET"
    },
    getNewsCountByMonth: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_ANALYTICAL}/getNewsCount/`,
        method: "GET"
    },

    getAllAnalyticsActiveUserCountUrl: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_ANALYTICAL}/activeUsersCount/`,
        method: "GET"
    },
    
    getAllAnalyticsNotificationCount: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_ANALYTICAL}/getNotificationTypesCount/`,
        method: "GET"
    },
    getAllAnalyticsMoodCount: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_ANALYTICAL}/user-mood-analytics/`,
        method: "GET"
    },

    getAllAnalyticsMoodCommentCount:{
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_ANALYTICAL}/user-mood-comments/`,
        method: "GET"
    },
    
    getAllDept:{
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_ANALYTICAL}/getDepartmentsList/`,
        method: "GET"
    },
    
    
    getAllAnalyticsSearchKeywordCount:{
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_ANALYTICAL}/search/keywords`,
        method: "GET"
    },
    
    getAllAnalyticsMostUsedFeatureCount:{
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_ANALYTICAL}/most-used-analytics`,
        method: "GET"
    },

    // Flag Details Urls
      
    getflagConfigDetails:{
        URL: `${process.env.REACT_APP_API_URL}/user-service/onemb-featureconfig`,
        method: "GET"
    },

    addflagConfigDetails:{
        URL: `${process.env.REACT_APP_API_URL}/user-service/onemb-featureconfig`,
        method: "GET"
    },

    updateflagConfigDetails:{
        URL: `${process.env.REACT_APP_API_URL}/user-service/onemb-featureconfig`,
        method: "GET"
    },

    deleteflagConfigDetails:{
        URL: `${process.env.REACT_APP_API_URL}/user-service/onemb-featureconfig`,
        method: "GET"
    },

    
    //Notification file api
    uploadSignatureImage: {
        URL: `${process.env.REACT_APP_API_URL}/file-service/uploadImage`,
        method:'POST'    
    },
    deleteSignatureImage: {
        URL: `${process.env.REACT_APP_API_URL}/notification-service/deleteImage`,
        method:'DELETE'
    },

    getAllSeries:{
        URL: `${process.env.REACT_APP_API_URL}/user-service/spinandwin/series`,
        method: "GET"
    },
    //Spin and win apis
    getSpinConfigDetails:{
        URL: `${process.env.REACT_APP_API_URL}/user-service/spinandwin/rewards`,
        method: "GET"
    },

    addSpinConfigDetails:{
        URL: `${process.env.REACT_APP_API_URL}/user-service/spinandwin/series`,
        method: "POST"
    },

    updateSpinConfigDetails:{
        URL: `${process.env.REACT_APP_API_URL}/user-service/spinandwin/series`,
        method: "PUT"
    },

    deleteSpinConfigDetails:{
        URL: `${process.env.REACT_APP_API_URL}/user-service/spinandwin/rewards`,
        method: "GET"
    },
    getSeriesById:{
        URL: `${process.env.REACT_APP_API_URL}/user-service/spinandwin/series/`,
        method: "GET"
    },
    publishSeries:{
        URL: `${process.env.REACT_APP_API_URL}/user-service/spinandwin/publishSeries`,
        method: "POST"
    },
    cloneSeries:{
        URL: `${process.env.REACT_APP_API_URL}/user-service/spinandwin/clone/series/`,
        method: "GET"
    },
    deleteSeries:{
        URL: `${process.env.REACT_APP_API_URL}/user-service/spinandwin/series`,
        method: "POST"
    },
    
    uploadSpinImage: {
        URL: `${process.env.REACT_APP_API_URL}/file-service/uploadImage`,
        method:'POST'    
    },
    deleteSpinImage: {
        URL: `${process.env.REACT_APP_API_URL}/user-service/spinandwin/rewardImage/`,
        method:'DELETE'
    },

    deletePhotoGallery:{
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/gallery/`,
    
        method: 'DELETE',
      },

    updateOrderId: {
        URL: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_URL_SURVEY}/mbrdinews/updateOrderId`,
        method: 'PUT',
    },

    // group APIs
     // group APIs
     getDept:{
        URL: `${process.env.REACT_APP_API_URL}/user-service/userFilter/departments`,
        method: "GET"
    },

    getAllLevel:{
        URL: `${process.env.REACT_APP_API_URL}/user-service/userFilter/levels`,
        method: "GET"
    },
    getAllUSersByFilter:{
        URL: `${process.env.REACT_APP_API_URL}/user-service/userFilter/filter`,
        method: "POST"
    },
    getAllGroups:{
        URL: `${process.env.REACT_APP_API_URL}/user-service/group`,
        method: "POST"
    },

    getUsersByGroup:{
        URL: `${process.env.REACT_APP_API_URL}/user-service/group/user`,
        method: "GET"
    },
    assignUsersToGroup:{
        URL: `${process.env.REACT_APP_API_URL}/user-service/group/user/add`,
        method: "POST"
    },
    
    unAssignUsersToGroup:{
        URL: `${process.env.REACT_APP_API_URL}/user-service/group/user/remove`,
        method: "POST"
    },
    
    getUsersByGroup:{
        URL: `${process.env.REACT_APP_API_URL}/user-service/group/user/`,
        method: "POST"
    },
    createGroup:{
        URL: `${process.env.REACT_APP_API_URL}/user-service/group`,
        method: "POST"
    },
    updateGroup:{
        URL: `${process.env.REACT_APP_API_URL}/user-service/group`,
        method: "POST"
    },
    getLocationDropdown:{
        URL: `${process.env.REACT_APP_API_URL}/user-service/userFilter/locationOption`,
        method: "POST"
    },
    getAllGroupCargeories:{
        URL: `${process.env.REACT_APP_API_URL}/user-service/group/dropdown/types`,
        method: "POST"
    },

    checkGroupNameDublicate:{
        URL: `${process.env.REACT_APP_API_URL}/user-service/group/avilableGroupName/`,
        method: "GET"
    },

    deleteGroupById:{
        URL: `${process.env.REACT_APP_API_URL}/user-service/group`,
        method: "Delete"
    },
   

    getCafeMenuhealthDeatls:{
        URL: `${process.env.REACT_APP_API_URL}/user-service/web/updateHealthyFoodBooking/`,
        method: "GET"
    },

    getBookingsByCurrentDate:{
        URL: `${process.env.REACT_APP_API_URL}/user-service/web/getHealthyFoodBookingByCurrentDateAndBuildingName`,
        method: "GET"
    },

    getTimeSlotsAndBuildingNames:{
        URL: `${process.env.REACT_APP_API_URL}/user-service/getTimeSlotsAndBuildingNames`,
        method: "GET"
    },
    getAllHealthyBookingDetails:{
        URL: `${process.env.REACT_APP_API_URL}/user-service/getHealthyFoodReport`,
        method: "GET"
    },
    
    
    getDepartmentNames:{

        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/getAllLabDetailsSchedule`,

        METHOD:"GET"

    },

   

    createLabDetailsSchedule:{

        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/createLabDetailsSchedule`,

        METHOD:"POST"

    },

     

    deleteLabDetailsById:{

        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/deleteLabDetailsSchedule/`,

        METHOD:"DELETE"

    },

   

    editLabDetails:{

        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/updateLabDetailsSchedule/`,

        METHOD:"PUT"


    },

    getUniqueDepartmentNames:{

        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/getAllDepartments`,

        METHOD:"GET"

    },

    getLabDetailsByLabNumber:{

        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/getLabDetailsByLabNumber?labNumber={labNumber}`,

        METHOD:"GET"

    },

   

    uploadMapImage:{

        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/upload/image/`,

        METHOD:"POST"

    },

    getAllLabMaps:{

        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/getAllLabMaps`,

        METHOD:"GET"

    },

    deleteLabMapImageId: {
        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/mapImage`,
        METHOD:"DELETE"
    },

    updateLabMapImageId : {
        URL:`${process.env.REACT_APP_API_URL}/onelab-service/upload/image/{labNumber}/LabMap`,
        METHOD:"PUT"

    },
    get_sas_token_map_image : {
        URL:`${process.env.REACT_APP_API_URL}/file-service/get-sas-token/lab-map-image`,
        METHOD:"GET"

    },
    getAllLabs : {
        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/getAllLabs`,
        METHOD:"GET"

    },

    getAllUsersToAprrove:{
        URL:`${process.env.REACT_APP_API_URL}/user-service/interestGroup/join`,
        METHOD:"GET"
    },

    getLabAuditResponse : {

        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/getLabAuditResponse`,
        METHOD:"GET"

    },
    getComplianceStatus : {

        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/getComplianceStatus`,
        METHOD:"GET"
    },
    getAllFieldsData : {

        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/getAllFieldsData`,
        METHOD:"GET"

     },
    getAllMonthlyLabAudit : {

        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/getAllMonthlyLabAudit`,
        METHOD:"GET"

    },
    createMonthlyLabAudit : {

        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/createMonthlyLabAudit`,
        METHOD:"POST"


    },
    createLabManual : {
        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/createLabManual`,
        METHOD:"POST"

     },
    uploadLabManualFiles : {
        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/uploadLabManualFiles`,
        METHOD:"POST"
    },
    getAllLabManuals : {
        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/getAllLabManuals`,
        METHOD:"GET"
    },
    getLabManualByLabNumber : {
       
        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/getLabManualByLabNumber`,
        METHOD:"GET"

    },
    deleteLabManualFile : {
        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/deleteLabManualFile`,
        METHOD:"DELETE"

    },
    deleteLabManual : {
        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/deleteLabManual`,
        METHOD:"DELETE"
    },
    exportLabManualDocument :{
        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/exportLabManualDocument`,
        METHOD:"GET"

    },
    labDetailsByLab : {
        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/labDetailsByLab`,
        METHOD:"GET"

    },
    getAllPendingApprovalLabManuals : {
        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/getAllPendingApprovalLabManuals`,
        METHOD:"GET"
    },
    getAllDeptsByLab : {
        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/getAllDeptsByLab`,
        METHOD:"GET"
    },
    getLabManual : {
        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/getLabManual`,
        METHOD:"GET"

    },
    addLabManualComments : {
        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/addLabManualComments`,
        METHOD:"POST"
    },
    approveLabManual : {
        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/approveLabManual`,
        METHOD:"PUT" 
    },
    updateLabManualContactInfo : {
        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/updateLabManualContactInfo`,
        METHOD:"PUT" 
    },
    updateLabManual : {
        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/updateLabManual`,
        METHOD:"PUT" 
    },
    getLabData : {
        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/getLabData`,
        METHOD:"GET"  
    },
    getLabDetailsByLab : {
        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/getLabDetailsByLab`,
        METHOD:"GET"  
    },
    rejectLabManual : {
        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/rejectLabManual`,
        METHOD:"PUT"
    },
    getMonthlyAuditLabDetails : {
        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/getMonthlyAuditLabDetails`,
        METHOD:"GET"
    },
    exportMonthlyAuditFile :{
        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/exportMonthlyAuditFile`,
        METHOD:"GET"
    },
    sendMonthlyAuditChecklistEmail : {
        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/sendMonthlyAuditChecklistEmail`,
        METHOD:"POST"
    },
    createDeptInventoryReport : {
        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/createDeptInventoryReport`,
        METHOD:"POST"
    },
    createLabInventoryReport :{
        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/createLabInventoryReport`,
        METHOD:"POST"
    },
    getDeptInventoryReport : {
        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/getDeptInventoryReport`,
        METHOD:"GET"
    },
    getLabInventoryReport : {
        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/getLabInventoryReport`,
        METHOD:"GET"
    },
    uploadMonthlyAuditFile : {
        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/uploadMonthlyAuditFile`,
        METHOD:"POST"
    },
    deleteMonthlyAuditImage : {
        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/deleteMonthlyAuditImage`,
        METHOD:"DELETE"
    },
    createTrainingCalendar : {
        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/createTrainingCalendar`,
        METHOD:"POST"
    },
    getTrainingCalendar : {
        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/getTrainingCalendar`,
        METHOD:"GET"

    },
    allMonthlyAudits : {
        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/allMonthlyAudits`,
        METHOD:"GET"
    },
    getMonthlyAudit :{
        URL:`${process.env.REACT_APP_API_URL}/onelab-service/oneLab/getMonthlyAudit`,
        METHOD:"GET"
    }


      
}